import { createAction, ActionType } from 'typesafe-actions';
import { NotificationActionModel, DialogActionModel } from './models';

export const setConfirmDialog = createAction('dialog/CONFIRM_ACTION')<DialogActionModel>();

export const setNotification = createAction('dialog/NOTIFICATION_ACTION')<NotificationActionModel>();

export type DialogAction = ActionType<typeof setConfirmDialog | typeof setNotification>;